import React, { Component } from "react";
import Redirect from "react-router/Redirect";
import Link from "react-router/Link";
import { Card, CardHeader, CardText } from "material-ui/Card";

import { Step, Stepper, StepLabel, StepContent } from "material-ui/Stepper";
import TextField from "material-ui/TextField";
import RaisedButton from "material-ui/RaisedButton";
import Done from "material-ui/svg-icons/action/done";

import { validateToken, validateEmail, registerUser } from "../actions/actions";
import apiErrors from "../modules/apierrors";
import getErrors from "../modules/geterrors";

// Taken from https://www.w3.org/TR/html5/forms.html#valid-e-mail-address
const emailRegexp = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

class Register extends Component {
  constructor(props) {
    super(props);

    let token = "";
    // Get the possible token from URL query string
    if (
      props.location.query &&
      typeof props.location.query.token === "string" &&
      props.location.query.token.length === 10
    ) {
      token = props.location.query.token;
      this.props.dispatch(validateToken({ key: token }));
    }

    this.state = {
      stepIndex: 0,
      form: {
        token,
        name: "",
        email: {
          value: "",
          error: ""
        },
        password: "",
        password_confirmation: ""
      }
    };
  }

  handleNext = () => {
    let { stepIndex } = this.state;

    if (stepIndex < 1) {
      stepIndex += 1;
      this.setState({ stepIndex });
    } else if (stepIndex === 1) {
      this.validateForm();
    }
  };

  validateForm = () => {
    const creds = {
      key: this.state.form.token,
      name: this.state.form.name,
      email: this.state.form.email.value,
      password: this.state.form.password,
      password_confirmation: this.state.form.password_confirmation
    };

    this.props.dispatch(registerUser(creds));
  };

  handleToken = event => {
    event.preventDefault();
    const form = { ...this.state.form };
    const key = this.tokenInput.getValue().trim();
    form.token = key;

    this.setState({ form });
    if (key.length === 10) {
      this.props.dispatch(validateToken({ key }));
    }
  };

  handleForm = event => {
    event.preventDefault();

    const form = { ...this.state.form };

    form.name = this.nameInput.getValue();
    form.email.value = this.emailInput.getValue();
    form.password = this.pwInput.getValue();
    form.password_confirmation = this.pw_confInput.getValue();

    const validEmail = form.email.value.match(emailRegexp);

    if (validEmail) {
      this.props.dispatch(validateEmail({ email: form.email.value }));
    }

    this.setState({ form });
  };

  renderStepActions(step, disabled, icon) {
    const { stepIndex } = this.state;

    const disabledNext = disabled;

    return (
      <div style={{ margin: "12px 0" }}>
        <RaisedButton
          type="submit"
          label={stepIndex === 1 ? "Create account" : "Next"}
          disabled={disabledNext}
          disableTouchRipple
          disableFocusRipple
          primary
          icon={icon}
          onTouchTap={this.handleNext}
          style={{ marginRight: 12 }}
        />
      </div>
    );
  }

  render() {
    if (this.props.auth.isAuthenticated) {
      return <Redirect to="/" />;
    }

    const token = this.props.validation.token;
    const email = this.props.validation.email;
    const disabled =
      this.state.form.token.length !== 10 ||
      !token.hasFetched ||
      !token.isValid;
    const disabledFinal =
      this.state.form.name.length < 2 ||
      this.state.form.password.length < 6 ||
      this.state.form.password_confirmation.length < 6 ||
      this.state.form.password !== this.state.form.password_confirmation ||
      !email.hasFetched ||
      !email.isValid;

    const localPassWordErrorMessage =
      this.state.form.password.length > 6 &&
      this.state.form.password_confirmation.length > 6 &&
      this.state.form.password !== this.state.form.password_confirmation
        ? "Password confirmation does not match"
        : "";

    const { validationErrors } = getErrors(this.props.registration.errors);
    const nameErrorMessage =
      apiErrors[validationErrors.name] || validationErrors.name;
    const emailErrorMessage =
      apiErrors[validationErrors.email] || validationErrors.email;
    const passwordErrorMessage =
      apiErrors[validationErrors.password] ||
      validationErrors.password ||
      localPassWordErrorMessage;

    let emailValidationError =
      email.isValid || !email.hasFetched ? "" : "This email is already in use";

    const { stepIndex } = this.state;

    const fetchingTokenMessage = this.props.isWaiting.VALIDATE_TOKEN
      ? "Validating token..."
      : "";
    let tokenError;
    let TokenButtonIcon;

    if (
      this.state.form.token.length === 10 &&
      token.hasFetched &&
      !token.isValid
    ) {
      tokenError = "Token not valid or the group is full";
    } else if (
      this.state.form.token.length === 10 &&
      token.hasFetched &&
      token.isValid
    ) {
      TokenButtonIcon = <Done />;
    }

    return (
      <div className="unregistered" key="registration">
        <Card>
          <CardHeader title="Create an account for Pronounce Live" />
          <CardText>
            <p>This registration is meant for organization users.</p>
          </CardText>
          <Stepper activeStep={stepIndex} orientation="vertical">
            <Step>
              <StepLabel>Input your token</StepLabel>
              <StepContent>
                <p>
                  You need a registration token to create an account and join a
                  user group. Ask your organization&apos;s administrator if you
                  don&apos;t have one.
                </p>
                <TextField
                  autoFocus
                  value={this.state.form.token}
                  errorText={tokenError}
                  onChange={this.handleToken}
                  ref={input => {
                    this.tokenInput = input;
                  }}
                  type="text"
                  name="key"
                  placeholder="token"
                />
                {fetchingTokenMessage}
                {this.renderStepActions(0, disabled, TokenButtonIcon)}
              </StepContent>
            </Step>
            <Step>
              <StepLabel>Create account</StepLabel>
              <StepContent>
                <TextField
                  errorText={nameErrorMessage}
                  onChange={this.handleForm}
                  ref={input => {
                    this.nameInput = input;
                  }}
                  floatingLabelText="Your name"
                  type="text"
                  name="name"
                  value={this.state.form.name}
                />
                <br />
                <TextField
                  onChange={this.handleForm}
                  ref={input => {
                    this.emailInput = input;
                  }}
                  errorText={emailValidationError || emailErrorMessage}
                  floatingLabelText="Email"
                  type="email"
                  name="email"
                  value={this.state.form.email.value}
                />
                <br />

                <TextField
                  errorText={passwordErrorMessage}
                  onChange={this.handleForm}
                  ref={input => {
                    this.pwInput = input;
                  }}
                  type="password"
                  name="password"
                  floatingLabelText="Password"
                  hintText="At least 6 characters"
                  value={this.state.form.password}
                />
                <br />
                <TextField
                  onChange={this.handleForm}
                  ref={input => {
                    this.pw_confInput = input;
                  }}
                  type="password"
                  name="password_confirmation"
                  floatingLabelText="Password Confirmation"
                  hintText="Match the password field"
                  value={this.state.form.password_confirmation}
                />
                <br />

                {this.renderStepActions(1, disabledFinal)}
              </StepContent>
            </Step>
          </Stepper>
        </Card>
      </div>
    );
  }
}

export default Register;



// WEBPACK FOOTER //
// ./src/components/Register.js